import UploadFileIcon from "@mui/icons-material/UploadFile";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { Accept, useDropzone } from "react-dropzone";

import { colors } from "theme";

import * as S from "./Dropzone.styled";

interface DropzoneProps {
  accept: Accept;
  id?: string;
  multiple?: boolean;
  onDrop?: (acceptedFiles: File[]) => void;
  typeLabel?: string;
}

export const Dropzone = ({ id, typeLabel, ...props }: DropzoneProps) => {
  const { getRootProps, getInputProps } = useDropzone({
    ...props,
    useFsAccessApi: false
  });

  return (
    <S.DropzoneContainer {...getRootProps()}>
      <input id={id} {...getInputProps()} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: colors.blueLight
          }}
        >
          <UploadFileIcon color="primary" />
        </Box>
        <Typography align="center">
          Click to upload or drag and drop{typeLabel ? ` (${typeLabel})` : ""}
        </Typography>
      </Box>
    </S.DropzoneContainer>
  );
};
